module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/six_btn-8939fa.png";